import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  initialMinutes?: number;
  className?: string;
  showLabels?: boolean;
}
export function CountdownTimer({
  initialMinutes = 15,
  className = '',
  showLabels = false
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60);
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          return initialMinutes * 60;
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [initialMinutes]);
  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  if (showLabels) {
    return <div className={`flex items-center gap-3 font-bold ${className}`} data-id="element-266">
        <div className="flex flex-col items-center" data-id="element-267">
          <span className="bg-[#E74C3C] text-white px-4 py-3 rounded-lg text-4xl md:text-5xl font-extrabold shadow-lg" data-id="element-268">
            {minutes}
          </span>
          <span className="text-xs mt-2 uppercase tracking-wider text-gray-300 font-semibold" data-id="element-269">
            MINUTOS
          </span>
        </div>
        <span className="text-4xl md:text-5xl text-white font-extrabold pb-6" data-id="element-270">
          :
        </span>
        <div className="flex flex-col items-center" data-id="element-271">
          <span className="bg-[#E74C3C] text-white px-4 py-3 rounded-lg text-4xl md:text-5xl font-extrabold shadow-lg" data-id="element-272">
            {seconds}
          </span>
          <span className="text-xs mt-2 uppercase tracking-wider text-gray-300 font-semibold" data-id="element-273">
            SEGUNDOS
          </span>
        </div>
      </div>;
  }
  return <span className={`font-mono font-bold ${className}`} data-id="element-274">
      {minutes}:{seconds}
    </span>;
}